import React, { useRef } from 'react';
import ReactDOM from 'react-dom';

import './index.module.less';

import { ConfirmProps, IExportedConfirm } from './index.d';

const promptContainer = document.createElement('div');
document.body.appendChild(promptContainer);

export const Confirm = React.forwardRef((props: ConfirmProps, ref) => {
  const {
    title,
    text,
    onConfirm,
    onCancel,
    cancelBtnText,
    confirmBtnText,
    showCancelBtn,
    ContentWidget,
    confirmTheme = 'primary',
    confirmBtnStyle,
    cancelBtnStyle,
    disabled,
    hideBtn = false
  } = props;
  const container = useRef(null);
  const isConfirm = useRef(null);
  const isMask = useRef(false);

  React.useImperativeHandle(ref, () => ({
    hide: () => {
      clickMask();
    },
  }));

  const animationEnd = (event: any): void => {
    if (!event || event.animationName === 'moveDown') {
      if (isConfirm.current) {
        onConfirm && onConfirm();
      } else {
        onCancel && onCancel(isMask.current ? 'mask' : 'cancel');
      }
      ReactDOM.unmountComponentAtNode(promptContainer as HTMLElement);
    }
  };

  const close = (event?: any): void => {
    if (event) {
      event.stopPropagation();
    }
    if (!event || event.target?.id) {
      const name = (container.current as any).className.replace(
        'in-up',
        'out-down',
      );
      (container.current as any).className = name;
    }
  };

  const clickMask = () => {
    isMask.current = true;
    close();
  };

  const confirm = async () => {
    if (disabled) {
      return;
    }
    isConfirm.current = true;
    close();
  };

  let confirmThemeStyle = {};
  switch (confirmTheme) {
    case 'primary':
      confirmThemeStyle = {
        background: '#1D70F2',
        color: '#FFFFFF',
      };
      break;
    case 'warn':
      confirmThemeStyle = {
        background: '#FDF3F4',
        color: '#E52E3D',
      };
      break;
    case 'normal':
      confirmThemeStyle = {
        background: '#F2F4F7',
        color: '#55585C',
      };
      break;
    //no default
  }

  const disabledStyle = {
    opacity: 0.3,
  };

  const confirmBtnStyles = {
    ...confirmThemeStyle,
    ...confirmBtnStyle,
    ...(disabled ? disabledStyle : {}),
  };

  return (
    <div id="containerModal" className="flex bg-modal" onClick={clickMask}>
      <div
        className="move-in-up"
        styleName="modal-content"
        ref={container}
        onAnimationEnd={animationEnd}
      >
        {title ? (
          <div className="flex" styleName="modal-title">
            {title}
          </div>
        ) : null}
        {ContentWidget ? (
          <div onClick={event => event.stopPropagation()}>{ContentWidget}</div>
        ) : (
          <>
            {text ? (
              <div className="flex" styleName="modal-text">
                {text}
              </div>
            ) : null}
          </>
        )}

        {hideBtn ? null :  (
          <div styleName="modal-bottom-wrapper">
            {showCancelBtn ? (
              <div className="flex" styleName="modal-multiple-btn-wrapper">
                <div
                  className="flex flex-center"
                  styleName="modal-cancel-btn"
                  id="close-btn"
                  onClick={close}
                  style={cancelBtnStyle ? cancelBtnStyle : {}}
                >
                  {cancelBtnText ? cancelBtnText : '取消'}
                </div>
                <div
                  className="flex flex-center"
                  styleName="modal-confirm-btn"
                  onClick={confirm}
                  style={confirmBtnStyles}
                >
                  {confirmBtnText ? confirmBtnText : '确定'}
                </div>
              </div>
            ) : (
              <div
                className="flex flex-center"
                styleName="modal-single-btn"
                onClick={confirm}
                style={confirmBtnStyles}
              >
                {confirmBtnText ? confirmBtnText : '确定'}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

const instanceRef: any = React.createRef();
const ExportedConfirm: IExportedConfirm = {
  show(options) {
    if (typeof options === 'string') {
      options = {
        title: options,
      };
    }
    ReactDOM.render(
      <Confirm ref={instanceRef} {...options} />,
      promptContainer,
    );
  },
  hide() {
    instanceRef.current?.hide();
  },
};

export default ExportedConfirm;
